import { Button, Container } from "reactstrap"
import styles from "./ViewCampaign.module.scss"
import Headphones from "../../../../../assets/images/product-image-headphones.png"
import DataTable from "react-data-table-component"
import BackButton from "../../../../../components/common/BackButton/BackButton"
import { useNavigate } from "react-router-dom"

const ViewCampaign = () => {
  const navigate = useNavigate()

  const data = [
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
    { productImage: Headphones, name: "Blue Clored Headphones", category: "Example123", sku: "Example123", stock: 300, campaignStock: "$33.33", price: 300 },
  ]

  const columns = [
    {
      name: "Product Image",
      cell: (row) => <img src={row.productImage} alt="" width={45} height={47} />,
      styles: {
        display: "flex",
        justifyContent: "center",
      },
    },
    {
      name: "Product Name",
      selector: (row) => row.name,
    },
    {
      name: "Category",
      selector: (row) => row.category,
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
    },
    {
      name: "Stock",
      selector: (row) => row.stock,
    },
    {
      name: "Compaign Stock",
      selector: (row) => row.campaignStock,
    },
    {
      name: "Price",
      selector: (row) => row.price,
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "1rem",
        fontWeight: 600,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <BackButton />
        <h5 className="fw-semibold mb-3">Product Submission for Campaign</h5>

        <div className={styles.addProductBtnContainer}>
          <Button type="button" color="primary" className={styles.productBtn} onClick={() => navigate("/marketing-options/campaigns/add-product")}>
            Add Products
          </Button>
        </div>

        <Container fluid className={`g-0 ${styles["wrapper"]}`}>
          <div className={styles["heading"]}>Added Product</div>
        </Container>
        <Container fluid className={`g-0 ${styles["table-wrapper"]}`}>
          <DataTable data={data} columns={columns} customStyles={customStyles} />
        </Container>
      </Container>
    </div>
  )
}

export default ViewCampaign
